import React from 'react';
import { Button } from '@material-ui/core';
import { useQueryClient } from 'react-query';

import useStyles from './RefetchProductsText.styles';

const RefetchProductsText = () => {
  const classes = useStyles();
  const queryClient = useQueryClient();

  const refetch = () => {
    queryClient.resetQueries('shopify-products', { exact: false });
  };

  return (
    <span className={classes.root}>
      🔄 Did you recently upload a product?
      {' '}
      <div className={classes.centered}>
        <Button
          className={classes.button}
          variant="text"
          onClick={refetch}
        >
          <u>Click here</u>
        </Button>
        {' '}
        to refresh your feed.
      </div>
    </span>
  );
};

export default RefetchProductsText;
